const PREFIX = "[PaymentSlip]";

export function getPaymentSlipUploadSessionKey(parcelId, recordSerialNo) {
  return `paymentSlipUploaded_${parcelId}_${recordSerialNo || "none"}`;
}

/** Clears upload flags so a new / reopened slip can call the API again. */
export function clearPaymentSlipUploadSessionFlags(parcelId, recordSerialNo) {
  if (parcelId != null && parcelId !== "") {
    sessionStorage.removeItem(`paymentSlipUploaded_${parcelId}`);
    sessionStorage.removeItem(
      getPaymentSlipUploadSessionKey(parcelId, recordSerialNo),
    );
  }
}

export function slipDebug(step, message, data) {
  if (data !== undefined) {
    console.log(`${PREFIX} ${step} — ${message}`, data);
  } else {
    console.log(`${PREFIX} ${step} — ${message}`);
  }
}

export function slipDebugWarn(step, message, data) {
  if (data !== undefined) {
    console.warn(`${PREFIX} ${step} — ${message}`, data);
  } else {
    console.warn(`${PREFIX} ${step} — ${message}`);
  }
}

export function slipDebugError(step, message, data) {
  if (data !== undefined) {
    console.error(`${PREFIX} ${step} — ${message}`, data);
  } else {
    console.error(`${PREFIX} ${step} — ${message}`);
  }
}
